import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import RequestTypeForm from "./RequestTypeForm";
import RequestType, { IRequestType } from "../../../model/request/RequestType";

export interface State {}

export interface UpdateRequestTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IRequestType;
}

class UpdateRequestTypeForm extends React.Component<
  UpdateRequestTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updatedRecord;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updatedRecord = RequestType(values);
          updatedRecord.code = rowData.code;
        }
      });
      return updatedRecord;
    });
  }

  render() {
    const { translate, rowData } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <RequestTypeForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
      />
    );
  }
}

export default UpdateRequestTypeForm;
